import { render } from "./criar_tela.vue?vue&type=template&id=508df8a1"
import script from "./criar_tela.vue?vue&type=script&lang=js"
export * from "./criar_tela.vue?vue&type=script&lang=js"

import "./criar_tela.vue?vue&type=style&index=0&id=508df8a1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__